module.exports = __webpack_public_path__ + "static/media/solaria360.53dd4aba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/solaria360.jpg
// module id = 1084
// module chunks = 0